"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _questionBanks = require("../selectors/questionBanks.js");
var _users = require("./users.js");
var _loading = require("./loading.js");
var _loading2 = require("../helpers/loading.js");
var CmeHooks = /*#__PURE__*/_createClass(function CmeHooks(_ref) {
  var _this = this;
  var Cme = _ref.Cme,
    CmeTracker = _ref.CmeTracker;
  _classCallCheck(this, CmeHooks);
  this.useCmeActivitiesWithTrackers = function () {
    var cmeActivities = (0, _reactRedux.useSelector)(function (state) {
      return state.cmeActivities;
    });
    var cmeQuestionBanks = (0, _reactRedux.useSelector)(function (state) {
      return state.cmeQuestionBanks;
    });
    var cmeActivityTrackers = (0, _reactRedux.useSelector)(function (state) {
      return state.cmeActivityTrackers;
    });
    var cmeCreditTrackers = (0, _reactRedux.useSelector)(function (state) {
      return state.cmeCreditTrackers;
    });
    var cmeCertificates = (0, _reactRedux.useSelector)(function (state) {
      return state.cmeCertificates;
    });
    var questionBanks = (0, _reactRedux.useSelector)(_questionBanks.selectQuestionBanksWithSubscriptions);
    var getCmeQuestionBank = function getCmeQuestionBank(cmeBanks, allQuestionBanks) {
      return cmeBanks.toList().find(function (cqb) {
        return allQuestionBanks.get(cqb.get('question_bank_id')).get('active');
      }) || cmeBanks.first();
    };
    return cmeActivities.toList().map(function (cmeActivity) {
      var filteredCmeCreditTrackers = cmeCreditTrackers.filter(function (cct) {
        return cct.get('cme_activity_id') === cmeActivity.get('id');
      });
      var cmeActivityTracker = cmeActivityTrackers.toList().find(function (cat) {
        return cat.get('cme_activity_id') === cmeActivity.get('id');
      });
      var filteredCmeQuestionBanks = cmeQuestionBanks.toList().filter(function (cqb) {
        return cqb.get('cme_activity_id') === cmeActivity.get('id');
      });
      var cmeQuestionBank = getCmeQuestionBank(filteredCmeQuestionBanks, questionBanks);
      var filteredCmeCertificates = cmeCertificates.toList().filter(function (certificate) {
        return certificate.get('cme_activity_id') === cmeActivity.get('id');
      });
      var questionBank = questionBanks.get(cmeQuestionBank.get('question_bank_id'));
      var creditsClaimed = filteredCmeCertificates.reduce(function (sum, cmeCertificate) {
        return sum + cmeCertificate.get('hours_used', 0);
      }, 0);
      var completed = creditsClaimed >= cmeActivity.get('cme_hours');
      var purchased = !filteredCmeCreditTrackers.isEmpty();
      var eligibleToRedeem = (cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('credits_earned')) > 0 && (cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('percent_correct', 0)) >= cmeActivity.get('minimum_percent_correct', 100) && !completed;
      return _objectSpread(_objectSpread(_objectSpread({}, cmeQuestionBank.toJS()), cmeActivity.toJS()), {}, {
        question_bank: questionBank.toJS(),
        cme_credit_trackers: filteredCmeCreditTrackers.toJS(),
        cme_activity_tracker: cmeActivityTracker.toJS(),
        credits_earned: cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('credits_earned'),
        questions_total_to_next_credit: cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('questions_total_to_next_credit'),
        incorrect_total: cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('incorrect_total'),
        percent_correct: cmeActivityTracker === null || cmeActivityTracker === void 0 ? void 0 : cmeActivityTracker.get('percent_correct'),
        questions_per_hour: filteredCmeQuestionBanks.map(function (cqb) {
          return cqb.get('questions_per_hour');
        }).min(),
        credits_claimed: creditsClaimed,
        completed: completed,
        purchased: purchased,
        eligibleToRedeem: eligibleToRedeem,
        questionBankIds: filteredCmeQuestionBanks.map(function (cqb) {
          return cqb.get('question_bank_id');
        })
      });
    });
  };
  this.useCmeActivitiesWithTrackersForQuestionBank = function (questionBankIdArg) {
    var questionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id', questionBankIdArg);
    });
    var cmeActivitiesWithTrackers = _this.useCmeActivitiesWithTrackers();
    return cmeActivitiesWithTrackers.filter(function (activity) {
      return activity.questionBankIds.includes(questionBankId);
    });
  };
  this.Cme = Cme;
  this.CmeTracker = CmeTracker;
  this.useCalculateCmeIfNeeded = function (questionBankIdArg) {
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var questionBankId = questionBankIdArg || selectedQuestionBankId;
    var calculateKey = Cme.cmeCalculate.getKey(questionBankId);
    var trackersKey = CmeTracker.cmeTrackersFetch.getKey(questionBankId);
    var dispatch = (0, _reactRedux.useDispatch)();
    var hasCme = (0, _reactRedux.useSelector)(function (state) {
      return state.questionBanks.getIn([questionBankId, 'has_cme']);
    });
    var tutorModeEnabled = (0, _users.useTutorModeEnabled)();
    var calculatingCme = (0, _loading.useIsLoading)(calculateKey);
    var calculatedCmeAt = (0, _loading.useLoadedAt)(calculateKey);
    var loadingCmeTrackers = (0, _loading.useIsLoading)(trackersKey);
    var loadedCmeTrackersAt = (0, _loading.useLoadedAt)(trackersKey);
    var syncingResponse = (0, _loading.useIsLoading)(/^quizzes\/\d+\/responses\/\d+(\/.+)?/);
    var calculatedThisSession = (0, _loading2.loadingPromiseDefined)(calculateKey);
    var trackersFetchedThisSession = (0, _loading2.loadingPromiseDefined)(trackersKey);
    (0, _react.useEffect)(function () {
      if (!hasCme || !questionBankId || syncingResponse) return;
      if (tutorModeEnabled) {
        if (calculatingCme || calculatedCmeAt && calculatedThisSession) return;
        dispatch(_this.Cme.cmeCalculate(questionBankId));
      } else {
        if (loadingCmeTrackers || loadedCmeTrackersAt && trackersFetchedThisSession) return;
        dispatch(_this.CmeTracker.cmeTrackersFetch(questionBankId));
      }
    }, [questionBankId, calculatedCmeAt, loadedCmeTrackersAt, syncingResponse]);
    return calculatingCme || loadingCmeTrackers || syncingResponse;
  };
  this.useCalculateAllCmeIfNeeded = function () {
    var calculateKey = Cme.cmeCalculate.getKey();
    var trackersKey = CmeTracker.cmeTrackersFetch.getKey();
    var dispatch = (0, _reactRedux.useDispatch)();
    var tutorModeEnabled = (0, _users.useTutorModeEnabled)();
    var calculatingCme = (0, _loading.useIsLoading)(calculateKey);
    var calculatedCmeAt = (0, _loading.useLoadedAt)(calculateKey);
    var loadingCmeTrackers = (0, _loading.useIsLoading)(trackersKey);
    var loadedCmeTrackersAt = (0, _loading.useLoadedAt)(trackersKey);
    var syncingResponse = (0, _loading.useIsLoading)(/^quizzes\/\d+\/responses\/\d+(\/.+)?/);
    var calculatedThisSession = (0, _loading2.loadingPromiseDefined)(calculateKey);
    var trackersFetchedThisSession = (0, _loading2.loadingPromiseDefined)(trackersKey);
    (0, _react.useEffect)(function () {
      if (syncingResponse) return;
      if (tutorModeEnabled) {
        if (calculatingCme || calculatedCmeAt && calculatedThisSession) return;
        dispatch(_this.Cme.cmeCalculate());
      } else {
        if (loadingCmeTrackers || loadedCmeTrackersAt && trackersFetchedThisSession) return;
        dispatch(_this.CmeTracker.cmeTrackersFetch());
      }
    }, [calculatedCmeAt, loadedCmeTrackersAt, syncingResponse]);
    return calculatingCme || loadingCmeTrackers || syncingResponse;
  };
}

/* useCmeActivitiesWithTrackers
*
* Returns all available CmeActivities for the current user.
* Automatically matches each CmeActivity to the best QuestionBank.
*
*/);

var _default = exports.default = CmeHooks;